import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BsArrowLeft, BsGeoAlt, BsTags } from 'react-icons/bs';
import Cabecalho from '../../../components/Cabecalho/Cabecalho';
import AccessDenied from '../../../components/AccessDenied';
import { hasPermission } from '../../../Utils/permissions';
import '../../Dashboard/styles/dashboard-modern.css';

export default function OpcoesBoletim() {
  const navigate = useNavigate();
  const options = [
    {
      title: 'Gerenciar Naturezas',
      description: 'Administrar o catálogo oficial e a classificação das ocorrências.',
      permission: 'naturezas.manage',
      path: '/administrador/naturezas',
      icon: <BsTags size={30} />,
    },
    {
      title: 'Cadastrar Bairros e Localidades',
      description: 'Gerenciar bairros, povoados e localidades vinculados aos municípios.',
      permission: 'localidades.manage',
      path: '/administrador/localidades',
      icon: <BsGeoAlt size={30} />,
    },
  ].filter(option => hasPermission(option.permission));

  if (!options.length) return <AccessDenied />;

  return <>
    <Cabecalho />
    <main className="dashboard-modern">
      <Container>
        <div className="dashboard-heading">
          <div>
            <p className="dashboard-eyebrow">Administração</p>
            <h2>Opções do Boletim</h2>
            <p className="dashboard-intro">Gerencie as configurações e os cadastros auxiliares utilizados nos boletins de ocorrência.</p>
          </div>
          <Button variant="outline-secondary" onClick={() => navigate('/dashboard')}>
            <BsArrowLeft className="me-2" /> Voltar ao painel
          </Button>
        </div>
        <Row className="g-3">
          {options.map(option => <Col key={option.path} xs={12} md={6}>
            <button type="button" className="dashboard-tile" onClick={() => navigate(option.path)}>
              <span className="tile-icon">{option.icon}</span>
              <span className="tile-copy">
                <span className="tile-title">{option.title}</span>
                <span className="tile-description">{option.description}</span>
              </span>
            </button>
          </Col>)}
        </Row>
      </Container>
    </main>
  </>;
}
